import { render, staticRenderFns } from "./Comments.vue?vue&type=template&id=493b067a&scoped=true"
import script from "./Comments.vue?vue&type=script&lang=js"
export * from "./Comments.vue?vue&type=script&lang=js"
import style0 from "./Comments.vue?vue&type=style&index=0&id=493b067a&prod&scoped=true&lang=css"
import style1 from "./Comments.vue?vue&type=style&index=1&id=493b067a&prod&lang=css"


/* normalize component */
import normalizer from "!../../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "493b067a",
  null
  
)

export default component.exports